module.exports = __webpack_public_path__ + "img/MWI.eec979e8.svg";